export default function FeatureSection({
  title,
  description,
  image,
  imageAlt,
  bullets = [],
  reverse = false,
  className = '',
}) {
  return (
    <section className={`py-16 md:py-20 ${className}`}>
      <div className="container mx-auto max-w-7xl px-6">
        <div className={`grid gap-12 lg:grid-cols-2 lg:gap-16 items-center`}>
          <div className={`${reverse ? 'lg:order-2' : ''} text-center lg:text-left`}>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">{title}</h2>
            {description && (
              <p className="text-lg text-muted-foreground mb-8 leading-relaxed">{description}</p>
            )}
            {bullets.length > 0 && (
              <ul className="space-y-4 text-left max-w-md mx-auto lg:mx-0">
                {bullets.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <svg className="h-6 w-6 text-primary shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {image && (
            <div className={`flex justify-center ${reverse ? 'lg:order-1 lg:justify-start' : 'lg:justify-end'}`}>
              <img
                src={image}
                alt={imageAlt || title}
                className="w-full max-w-xl rounded-xl shadow-2xl"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
